import React, { ReactNode } from 'react';
import { observer } from 'mobx-react';
import { EditIcon, Button } from '@gamesb42/ui-kit';

import { Title3, Text2 } from 'pages/Connection/components/Typography';
import connectionStore, {
  DrawerScreens,
} from 'pages/Connection/components/connectionStore';
import appStore from 'store/App';

import addedIcon from 'pages/Connection/assets/added.png';
import plusIcon from 'pages/Connection/assets/plus.png';

import s from './styles.module.scss';

interface OnboardingBlockProps {
  title: string;
  description: string;
  isCompleted: boolean;
  isAllCompleted: boolean;
  screenName: DrawerScreens;
  buttonText?: string;
  showWhen?: boolean; // Условие показа блока (например, для Corporate Documents)
  disabled?: boolean;
  children?: ReactNode;
}

const OnboardingBlock: React.FC<OnboardingBlockProps> = observer(
  ({
    title,
    description,
    isCompleted,
    isAllCompleted,
    screenName,
    buttonText = 'Add information',
    showWhen = true,
    disabled = false,
    children,
  }) => {
    const handleButtonClick = () => {
      connectionStore.currentScreen = screenName;
      appStore.showAccountsDrawer = true;
    };

    const handleEditClick = () => {
      connectionStore.currentScreen = screenName;
      appStore.showAccountsDrawer = true;
    };

    // Если условие не выполнено, не показываем блок
    if (!showWhen) {
      return null;
    }

    return (
      <div
        style={{ height: isCompleted ? '56px' : 'auto' }}
        className={s.whiteBlock}
      >
        {!isCompleted && (
          <>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '12px',
              }}
            >
              <img src={plusIcon} alt="icon" />
              <Title3 className={s.whiteBlockTitle}>{title}</Title3>
            </div>
            <Text2>{description}</Text2>

            {children}

            <div className={s.bottom} style={{ marginTop: '36px' }}>
              <Button
                type="primary"
                htmlType="submit"
                onClick={handleButtonClick}
                className={`${s.submitBtn} ${s.violetButton}`}
                disabled={disabled}
              >
                {buttonText}
              </Button>
            </div>
          </>
        )}

        {isCompleted && (
          <Title3 className={s.whiteBlockTitleAdded}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <img src={addedIcon} alt="icon" />
              <Title3 className={s.whiteBlockTitle}>{title}</Title3>
            </div>
            {!isAllCompleted && (
              <Button
                type="iconBtn"
                onClick={handleEditClick}
                icon={<EditIcon />}
              />
            )}
          </Title3>
        )}
      </div>
    );
  },
);

export default OnboardingBlock;
